const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/fields/metakat/VersicherungsdeckungField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import { CIS4mMetaKatDropDown } from '@cistec/common_web/modules/CIS4m/components/CIS4mMetaKatDropDown';
import { MessageDescriptor } from '@formatjs/intl';
import { useCIS4FormMetaKatData } from 'App/store/cis4m';


interface Props {
    label: string | MessageDescriptor;
    path: string;
    hidden?: boolean;
    required?: boolean;
}

export const VersicherungsdeckungField = forwardRef((props: Props, ref: any) => {
    const { formatMessage, locale } = useIntl();
    const dropdownRef = useCIS4m(ref);
    const label = typeof props.label === 'string' ? props.label : formatMessage(props.label);
    const hidden = props.hidden ?? false;
    const required = props.required ?? false;

    return (
        <CIS4mMetaKatDropDown
            ref={dropdownRef}
            label={label}
            path={props.path}
            pcode={'b53408b8-9c98-4877-8e40-7a0bcb131eac'}
            valuePath="FKEY"
            labelPath={`CONTENT.Lang.${locale}`}
            hidden={hidden}
            required={required}
            dataHook={useCIS4FormMetaKatData}
        />
    );
});

VersicherungsdeckungField.displayName = 'VersicherungsdeckungField';
